import React from 'react';
import { ConditionalWrapper, Box, GemOutlined, Tooltip } from '@landr/maestro';
import { t } from '@lingui/macro';
import { css } from '@landr/styled-system/css';

const badgeStyles = css({
    borderRadius: 'lg',
    width: '38px',
    height: '32px',
    backgroundColor: 'purple.500',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,

    '&[data-absolute="true"]': {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 'base',
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: '25%',
    },
});

const absoluteWrapperStyles = css({
    position: 'absolute',
    top: 0,
    right: 0,
});

export const ExclusivePackBadge: React.FC<{
    isAbsolute?: boolean;
}> = ({ isAbsolute = false }) => {
    const exclusiveLabel = t`Exclusive`;

    return (
        <ConditionalWrapper
            condition={isAbsolute}
            wrapper={(children: React.ReactNode): React.ReactNode => (
                <Box className={absoluteWrapperStyles}>{children}</Box>
            )}
        >
            <Tooltip label={exclusiveLabel}>
                <Box
                    className={badgeStyles}
                    data-absolute={isAbsolute}
                    aria-label={exclusiveLabel}
                >
                    <GemOutlined size="sm" color="gray.50" />
                </Box>
            </Tooltip>
        </ConditionalWrapper>
    );
};

export default ExclusivePackBadge;
